import MainLayout from "../layouts/main-layout";
export default function RenderNoteBook() {
  return (
    <MainLayout>
      <h1>Note Book</h1>
      
    </MainLayout>
  );
}
